import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  private apiEndPoint = environment.APIEndpoint;

  private eventActionSubject = new Subject<any>();
  public getEventAction = this.eventActionSubject.asObservable();

  constructor(private http: HttpClient) { }

  sendEventAction(data: any) {
    this.eventActionSubject.next(data);
  }

  fetchEvents(fromDate, toDate, checkedFilters): Observable<any> {
    let params = new HttpParams();
    params = params.append('from_date', fromDate);
    params = params.append('to_date', toDate);
    checkedFilters.forEach(item => {
      params = params.append(item.id, item.isChecked);
    });

    return this.http.get<any>(this.apiEndPoint + '/events', { params });
  }

  addEvent(postData: any) {
    return this.http.post<any>(this.apiEndPoint + '/events/add', postData);
  }

  editEvent(postData: any) {
    return this.http.patch<any>(this.apiEndPoint + '/events/edit', postData);
  }

  deleteEvent(postData: any) {
    let params = new HttpParams();
    params = params.append('event_id', postData['event_id']);
    params = params.append('event_type', postData['event_type']);

    return this.http.delete<any>(this.apiEndPoint + '/events/delete', { params });
  }


  deleteEventWebinarSession(postData: any) {
    let params = new HttpParams();
    params = params.append('meeting_session_id', postData['meeting_session_id']);
    params = params.append('type', postData['type']);
    return this.http.delete<any>(this.apiEndPoint + '/mentor/meetings/delete', {params});
  }
}
